<template>
  <div class="o-layout">
    <div class="o-layout__item u-padding-top-large u-padding-bottom-medium">
      <h3 class="c-title c-title--page-section">{{$t('event.access.passwords')}}</h3>
    </div>
    <div class="o-layout__item">
      <form id="eventPasswords">
        <scePasswordField :label="currentPasswordLabel" v-model="current"/>

        <div class="c-input--extra-info">
          {{ $t('eventPasswords.minimumLength') }}
        </div>

        <scePasswordField label="role.organiser" name="role.organiser" v-model="eventPasswords.organiser" :config="{ showStrength: true }"
                          v-validate data-vv-rules="min:8" :class="{'is-invalid': errors.has('role.organiser')}"/>
        <scePasswordField label="role.judge" name="role.judge" v-model="eventPasswords.judge" :config="{ showStrength: true }"
                          v-validate data-vv-rules="min:8" :class="{'is-invalid': errors.has('role.observer')}"/>
        <scePasswordField label="role.supervisor" name="role.supervisor" v-model="eventPasswords.supervisor" :config="{ showStrength: true }"
                          v-validate data-vv-rules="min:8" :class="{'is-invalid': errors.has('role.supervisor')}"/>
        <scePasswordField label="role.observer" name="role.observer" v-model="eventPasswords.observer" :config="{ showStrength: true }"
                          v-validate data-vv-rules="min:8" :class="{'is-invalid': errors.has('role.observer')}"/>
      </form>
    </div>
    <div class="o-layout__item">
      <sceButton label="save" class="c-button--primary c-button--large" v-on:click="savePasswords()" />
    </div>
  </div>
</template>

<script>
import config from '@/config'

import forOwn from 'lodash/forOwn'

export default {
  name: "EventPasswords",
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['events', 'organisations'].includes(value)
    },
    typeId: {
      type: String,
      required: true
    },
  },
  data: function() {
    return {
      currentPasswordLabel: '',
      current: null,
      passwordCheck: null,
      eventPasswords: {
        organiser: null,
        judge: null,
        supervisor: null,
        observer: null,
      },
    }
  },
  created: function () {
    this.currentPasswordLabel = this.$t('oldPassword') + ' - '
    if (this.$store.state.user.roles.general === 'event') {
      this.currentPasswordLabel += this.$t('role.organiser')
      this.passwordCheck = 'event'
    }
    else {
      this.currentPasswordLabel += this.$store.state.user.instance.name
      this.passwordCheck = 'user'
    }
  },
  methods: {
    savePasswords: function() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          const data = {
            check: this.passwordCheck,
            eventPasswords: [],
            current: this.current,
          }

          forOwn(this.eventPasswords, (password, key) => {
            if (password?.length) {
              data.eventPasswords.push({role: key, password: password})
            }
          })

          this.$notify.notifyAsync(
              this.$http.post(config.root + '/'+ this.type + '/' + this.typeId + '/update-passwords', {data}),
              this.$t('event.access.passwords.saving'),
              this.$t('event.access.passwords.saved'),
              (error) => {
                return this.$t('event.access.passwords.failed', {error: error.message})
              }
          )
        }
      })
    },
  },
}
</script>
